"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeQueryParamKey = exports.Theme = void 0;
var Theme;
(function (Theme) {
    Theme["APOLLO"] = "apollo";
    Theme["CONSTELLATION"] = "constellation";
    Theme["DEFAULT"] = "default";
    Theme["INVEST"] = "apollo";
    Theme["PERSONAL_ADVISOR"] = "personalAdvisor";
    Theme["PERSONAL_ADVISOR_SELECT"] = "personalAdvisorSelect";
})(Theme = exports.Theme || (exports.Theme = {}));
var ThemeQueryParamKey;
(function (ThemeQueryParamKey) {
    ThemeQueryParamKey["THEME_ALL"] = "theme";
    ThemeQueryParamKey["STYLES"] = "themeStyles";
})(ThemeQueryParamKey = exports.ThemeQueryParamKey || (exports.ThemeQueryParamKey = {}));
